<template>
    <article>
        <ContentBlockList :blocks="model.blocks"/>
    </article>
</template>

<script lang="ts">
import { HomePage } from '@/api/content/models';
import { defineComponent, PropType } from 'vue';
import ContentBlockList from '@/core/content/ContentBlockList.vue';
import useTheme from '@/core/theme/useTheme';

export default defineComponent({
    name: 'HomePage',
    components: { ContentBlockList },
    props: {
        model: {
            type: Object as PropType<HomePage>,
            required: true,
        },
    },
    setup(props) {
        const { setThemeBackgroundColor } = useTheme();
        setThemeBackgroundColor(props.model.pageBackgroundColor);
    },
});
</script>
